import invariant from 'invariant';
// export { AutoFieldProps } from 'uniforms';
import { createAutoField } from 'uniforms';

import BoolField from '../src/BoolField';
import DateField from '../src/DateField';
import ListField from '../src/ListField';
import NestField from '../src/NestField';
import NumField from '../src/NumField';
import RadioField from '../src/RadioField';
import SelectField from '../src/SelectField';
import TextField from '../src/TextField';

const AutoField = createAutoField((props) => {
  if (props.component) {
    return props.component;
  }

  if (props.options) {
    return props.checkboxes && props.fieldType !== Array ? RadioField : SelectField;
  }

  switch (props.fieldType) {
    case Array:
      return ListField;
    case Boolean:
      return BoolField;
    case Date:
      return DateField;
    case Number:
      return NumField;
    case Object:
      return NestField;
    case String:
      return TextField;
  }

  return invariant(false, 'Unsupported field type: %s', props.fieldType);
});

export default AutoField;
